module.exports = __webpack_public_path__ + "img/git.d604cdcf.png";